module.exports = __webpack_public_path__ + "img/DateTimeRange.6793f2c3.svg";